module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-BlackItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-BlackItalic.eot
 ** module id = 349
 ** module chunks = 0
 **/